import React from "react";

// This wrapper ensures that the imported component uses the same React instance
export const ImportedComponentWrapper: React.FC = () => {
  const [ImportedComponent, setImportedComponent] =
    React.useState<React.ComponentType | null>(null);

  React.useEffect(() => {
    // Dynamically import the component only on the client side
    if (typeof window !== "undefined") {
      import("@headless/lib/system-selector/system-selector.component")
        .then((module) => {
          setImportedComponent(() => module.SystemSelector);
        })
        .catch((error) => {
          console.error("Failed to load ImportedComponent:", error);
        });
    }
  }, []);

  if (!ImportedComponent) {
    return <div>Loading...</div>;
  }

  return <ImportedComponent />;
};

// export default ImportedComponentWrapper;
